import { makeAutoObservable } from "mobx";
import { PProductError } from "./PProductError";
import { PProductUnavailabilityDetails } from "./PProductInstanceUnavailabilityDetails";
import { PTemporarilyUnavailableIngredients } from "./PTemporarilyUnavailableIngredients";
export class PProductInstanceCreatorPart {
    constructor(params) {
        this.domain = params.domain;
        this.productInstancePartAvailabilityService =
            params.productInstancePartAvailabilityService;
        this.possibleProductTypes = params.possibleProductTypes;
        this.productType = params.productType;
        this._modifierInstanceCreators = params.modifierInstanceCreators;
        this.restaurant = params.restaurant;
        this.creatorScopeProvider = params.creatorScopeProvider;
        this.fulfillmentTimeScope = params.fulfillmentTimeScope;
        makeAutoObservable(this);
    }
    get productTypeId() {
        return this.productType.id;
    }
    get productName() {
        return this.productType.name;
    }
    get productBaseIngredients() {
        return this.productType.baseIngredients;
    }
    get productTags() {
        return this.productType.tags;
    }
    get productAllergens() {
        return this.productType.allergens;
    }
    get productPhoto() {
        return this.productType.photo;
    }
    get productDescription() {
        return this.productType.description;
    }
    get productFreeModifierItemsCount() {
        return this.productType.freeModifierItemsCount;
    }
    get availability() {
        return this.productInstancePartAvailabilityService.availability(this.domain.productInstancePart, this.creatorScopeProvider.parameterSet, this.fulfillmentTimeScope.fulfillmentTime);
    }
    get unavailabilityDetails() {
        return new PProductUnavailabilityDetails({
            availability: this.availability,
            restaurant: this.restaurant,
        });
    }
    get isSubmitVisible() {
        const { error } = this.unavailabilityDetails;
        if (error === null) {
            return true;
        }
        switch (error.type) {
            case "VisibilityUnavailability":
            case "TemporarilyUnavailable":
                return false;
            case "PreorderUnavailability":
            case "ScheduleUnavailability":
            case "ParametersUnavailability":
            case "UnknownUnavailability":
                return true;
        }
    }
    get error() {
        const { parametersDetails, error } = this.unavailabilityDetails;
        if (error !== null && error.type === "ParametersUnavailability") {
            return PProductError.unavailable(parametersDetails);
        }
        return null;
    }
    get modifierInstanceCreators() {
        return this._modifierInstanceCreators.filter((m) => m.isVisible);
    }
    validate() {
        this.modifierInstanceCreators.forEach((m) => m.creatorConfigValidation.validate());
    }
    get temporarilyUnavailableIngredients() {
        return this._modifierInstanceCreators
            .map((m) => m.temporarilyUnavailableIngredients)
            .reduce((prev, curr) => prev.union(curr), PTemporarilyUnavailableIngredients.empty());
    }
}
